import React from 'react';

import { Flex } from '@adsk/alloy-react-box';
import { HammerIcon } from '@adsk/alloy-react-icon';
import ProgressBar from '@adsk/alloy-react-progress-bar';
import theme from '@adsk/alloy-react-theme';

import {
  DEFAULT_TASK_STATUS,
  TASK_SUB_TYPE_ICONS,
} from './PlanTaskEntityBlockStatusSummary.consts';
import PlanTaskStatus from './PlanTaskStatus/PlanTaskStatus';
import { Task } from '../../../types';

interface PlanTaskEntityBlockDateSummaryProps {
  task: Task;
}

const PlanTaskEntityBlockStatusSummary = ({
  task,
}: PlanTaskEntityBlockDateSummaryProps) => {
  const calculateSubTypeIcon = () => {
    if (!task.subType) {
      return HammerIcon;
    }

    return TASK_SUB_TYPE_ICONS[task.subType];
  };

  const status = task.status ?? DEFAULT_TASK_STATUS;
  const completionPercentage = task.completionPercentage
    ? task.completionPercentage * 100
    : 0;

  const TaskSubTypeIcon = calculateSubTypeIcon();

  return (
    <Flex
      alignItems="center"
      typography="bodySmall"
      color="charcoal900"
      style={{ gap: '16px' }}
    >
      <Flex alignItems="center" style={{ gap: '16px' }}>
        <TaskSubTypeIcon size={20} color={theme.colors.charcoal500} />
        <PlanTaskStatus status={status} />
      </Flex>
      <Flex alignItems="center" style={{ gap: '8px' }}>
        <ProgressBar style={{ width: 56 }} now={completionPercentage} />
        <div>{`${completionPercentage}%`}</div>
      </Flex>
    </Flex>
  );
};

export default PlanTaskEntityBlockStatusSummary;
